import {Tabs, Tab, Grid} from '@mui/material';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import {TAB_MISSING, TAB_CITY_MISSING} from './StatsCommon.js';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import StatsMonthMissing from './StatsMonthMissing.js';
import StatsCityMissing from './StatsCityMissing.js';
import StatsYearMissing from './StatsYearMissing.js';
import StatsDateMissing from './StatsDateMissing.js';

const StatsMissing = observer(() => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	const handleTabChange = (event, tab) => {
		gStorage.stats.setObsList(null);
		gStorage.stats.setMissingTab(tab + TAB_CITY_MISSING);
	}

	if (gStorage.stats.tab !== TAB_MISSING)
		return null;

	return (
		<>
			<Grid container direction="row" justifyContent="center" spacing={0} columns={1}>
				<Tabs
					value={gStorage.stats.missing_tab - TAB_CITY_MISSING}
					onChange={handleTabChange} 
					align={'center'}
					indicatorColor="primary"
					textColor="primary"
					scrollButtons="auto"
					variant="scrollable"
					sx={{mb: 1}}>
					<Tab label={t('stats.city_missing')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.date_missing')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.month_missing')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.year_missing')} disabled={!gStorage.conn.online}/>
				</Tabs>
			</Grid>

			<StatsCityMissing/>
			<StatsDateMissing/>
			<StatsMonthMissing/>
			<StatsYearMissing/>
		</>
	);
});

export default StatsMissing;
